import { render, staticRenderFns } from "./persona-selector.vue?vue&type=template&id=32f8d4c6&"
import script from "./persona-selector.vue?vue&type=script&lang=js&"
export * from "./persona-selector.vue?vue&type=script&lang=js&"
import style0 from "./_persona-selector.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports